import React from 'react';
import ReactSound from 'react-sound';
import styled from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';

import runaway from '../sounds/play-runaway.ogg';
import { useSelector } from 'react-redux';
import Img from 'react-image';
import soundPlayerIntro from '../sounds/play-player-intro.mp3';
import AnimationWithSound from '../AnimationWithSound';

const RUNAWAY_SOUND_DURATION = 3000; // milliseconds

export const PLAYER_STATE = {
  NOT_DISPLAYED: 0,
  FIGHTING_START: 1,
  FIGHTING: 2,
  LOSE: 3,
  RUNAWAY: 4,
};

const Player = ({ state, handleOnDoubleClick, handleOnRunaway }) => {
  const { images } = useImagesContext();
  const config = useSelector((state) => state.config);

  console.debug('Player state', state);

  return (
    <>
      {state === PLAYER_STATE.FIGHTING_START && (
        <AnimationWithSound
          imageUrl={images['play-player-intro.png']}
          soundFile={soundPlayerIntro}
          playSound={!config.isMutedSound}
        />
      )}

      <Block
        onDoubleClick={handleOnDoubleClick}
        src={images['play-player.png']}
        $zIndex={state === PLAYER_STATE.FIGHTING ? 0 : -1}
      />
      {state === PLAYER_STATE.LOSE && (
        <Block src={images['play-player-lose.png']} />
      )}
      {state === PLAYER_STATE.RUNAWAY && (
        <AnimationWithSound
          onSoundEnd={handleOnRunaway}
          imageUrl={images['play-runaway.png']}
          soundFile={runaway}
          playSound={!config.isMutedSound}
        />
      )}
    </>
  );
};

const Block = styled.img`
  position: absolute;
  bottom: 10px;
  left: 142px;
  z-index: ${(props) => props.$zIndex};
`;

const FullScreenImage = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 10;
`;

export default Player;
